import {Pipe, PipeTransform} from "@angular/core";
import {StorageFileType} from "../../model/storageFileType";

@Pipe({name: 'fileType'})
export class FileTypePipe implements PipeTransform {
    transform(value: any) {
        return StorageFileType[value];
    }
}
